module.exports = __webpack_public_path__ + "static/media/ic_banner_default.175294a7.png";